module.exports = __webpack_public_path__ + "img/home-cover.42300685.jpeg";